import { Box, Button, Grid, Modal, Tab, Tabs } from "@mui/material";
import { FormProvider, UseFormReturn } from "react-hook-form";
import {
  RHFDateTimePicker,
  RHFTextField,
} from "../../../../../RHFComponents/RHFComponents";

export default function MedPresl(props: {
  methods: UseFormReturn<any>;
  showModale: boolean;
  setShowModale: (value: boolean) => void;
  submitFunction: () => Promise<void>;
}) {

  return (
    <Modal open={props.showModale}>
      <FormProvider {...props.methods}>
        <Box
          sx={{
            maxHeight: "90vh",
            maxWidth: "150vh",
            width: "50%",
            overflow: "auto",
            paddingTop: 1,
            backgroundColor: "white",
            borderRadius: 2,
            boxShadow: 24,
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          <Tabs value={0} sx={{ paddingLeft: 2 }}>
            <Tab
              sx={{
                fontFamily: "Montserrat",
                fontWeight: "bold",
                textTransform: "none",
              }}
              label="Importi di Listino del Medico/Risorsa"
            />
          </Tabs>
          <Grid container spacing={2} padding={2}>
            <Grid item xs={12} md={12}>
              <RHFDateTimePicker
                label="Data Inizio"
                dateOnly
                fullWidth
                name="dataIniValidita"
                serialize="dayjs"
                control={props.methods.control}
              />
            </Grid>
            <Grid item xs={12} md={12}>
              <RHFTextField
                control={props.methods.control}
                name="importoListino"
                label="Importo Listino"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={12}>
              <RHFTextField
                control={props.methods.control}
                name="importoPaz"
                label="Importo Paziente"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={12}>
              <RHFTextField
                control={props.methods.control}
                name="importoEnte"
                label="Importo Ente"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={12} width={"100%"}>
              <Grid container display={"flex"} justifyContent={"space-between"}>
                <Grid item>
                  <Button
                    variant="outlinedCustom"
                    onClick={() => props.setShowModale(false)}
                  >
                    Indietro
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    variant="containedCustom"
                    onClick={props.methods.handleSubmit(async () => {
                      await props.submitFunction();
                    })}
                  >
                    Conferma
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </FormProvider>
    </Modal>
  );
}
